<template lang="pug">
    v-container
        .header.d-flex.justify-space-between.align-center.mb-10.white--text
            h1 {{$t("users.title")}}
            CreateEditUserDialog
            //- create-edit-user-dialog(:user="createUser" :edit="false")
        v-row(v-if="users && users.length > 0")
            v-col(v-for='user in users' :key='user.Username' cols='12' md="6" xl="4")
                TenantUserCard(:user="user")
        v-row(v-else)
            v-col(v-for='(item, i) in 9', :key='i' cols='12' md="6" xl="4")
                v-skeleton-loader.mb-2.elevation-25( type="table-heading, list-item-two-line, table-tfoot")
        

</template>

<script>
import { mapState } from "vuex";
import TenantUserCard from "@/components/admin/TenantUserCard";
import CreateEditUserDialog from "@/components/admin/CreateEditUserDialog";
import date from "@/utils/date";
export default {
  components: {
    TenantUserCard,
    CreateEditUserDialog,
  },
  data() {
    return {};
  },
  methods: {
    ...date,
  },
  computed: {
    ...mapState({ users: (state) => state.superAdmin.users }),
  },
  mounted() {
    this.$store.dispatch("superAdmin/FETCH_USERS");
  },
};
</script>

<style></style>
